import { faFilePdf, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import ConfigService from "../../../services/configuracion/ConfigService";
import AuthService from "../../../services/login/auth.service";
import ButtonLink from "../../generico/ButtonLink";
import history from "../login/history";
import authService from "../../../services/login/auth.service";
import { trackPromise } from "react-promise-tracker";
import HabilitarAhorroProgramadoService from "../../../services/autogestion/HabilitarAhorroProgramadoService";

const paginationOptions = {
  rangeSeparatorText: "de",
  rowsPerPageText: 'Filas por página',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos'
  //noRowsPerPage:true
};

const MOVIMIENTO_AHORRO_PROGRAMADO = 62;

export default class AhorroProgramado extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log(this.props.ahorroProgramado)
  }

  getColumnDetalle() {
    return [
      {
        name: "Cuenta",
        selector: row => row.cuenta

      },
      {
        name: "Moneda",
        selector: row => row.moneda,

      },
      {
        name: "Cuota",
        selector: row => row.cuota,

      },
      {
        name: "Fecha Vencimiento",
        selector: row => row.fechaVencimiento

      },
      {
        name: "Saldo Total",
        selector: row => row.saldoTotal

      },
      {
        name: "Saldo Pendiente",
        selector: row => row.pendiente

      },
      {
        cell: (row) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <ButtonLink
              className="btn btn-cu-secundary btn-sm mb-1"
              param={row}
              url={ConfigService.getPathById(MOVIMIENTO_AHORRO_PROGRAMADO)?.url}
              onClick={this.movimientos}>
              <FontAwesomeIcon icon={faEye} style={{ color: "#fff" }} /> Ver Movimientos
            </ButtonLink>
            <button
              className="btn btn-cu-secundary btn-sm"
              style={ConfigService.ocultarSegunNombre("verContratoAhorroProgramado")}
              hidden={row.idModalidad === "59"}
              onClick={() => this.reimprimirContrato(row)}>
              <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} /> Ver Contrato
            </button>
            
          </div>
        ),
        right: true,
        width: "250px"
      }

    ];
  }
  movimientos = (url, row) => {
    //console.log(row)
    sessionStorage.setItem("AH", row.cuenta);
    sessionStorage.setItem("tipo", "AP");
    history.push(url);
    window.location.reload();
  }

  reimprimirContrato = async (row) => {

    let usuario = authService.getSocio();
    await trackPromise(
      HabilitarAhorroProgramadoService.descargarContrato(
        usuario.nombreCompleto.trim(),
        usuario.numeroCedula,
        usuario.numeroSocio.trim(),
        usuario.direccionParticular,
        usuario?.celular ? usuario?.celular : usuario?.telefonoParticular,
        row.cuenta,
        row.importeCuota,
        row.plazo,
        row.fechaVencimiento,
        row.fechaApertura)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }

  render() {
    return (
      <DataTable
        noHeader={true}
        pagination={true}
        columns={this.getColumnDetalle()}
        data={this.props.ahorroProgramado}
        paginationComponentOptions={paginationOptions}
        noDataComponent="no hay registros para mostrar"
        responsive={true}
        striped={true} />

    );
  }
}